import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Chip } from '@mui/material';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import InvButton from '../components/InvButton';
import { invChipSx } from '../components/StatusChip';
import { BASE_URL } from '../constants';
import { healthCheck } from '../api/inventory-request';
import { IPD_COLORS } from '../theme';

export default function Settings() {
  const [healthy, setHealthy] = useState(undefined);
  const [checking, setChecking] = useState(false);

  async function check() {
    setChecking(true);
    // API: GET /inventory/items/ — connectivity health check
    setHealthy(await healthCheck());
    setChecking(false);
  }

  useEffect(() => { check(); }, []);

  return (
    <Box>
      <PageHeader
        eyebrow="Hlthtek Inventory Suite"
        title="Settings"
        description="Inventory API connection"
      />

      <Grid container spacing={2.5}>
        <Grid item xs={12} md={7}>
          <SectionCard title="API Base URL">
            <Typography sx={{ color: IPD_COLORS.textPrimary, fontSize: 13, wordBreak: 'break-all' }}>
              {BASE_URL}
            </Typography>
            <Typography sx={{ color: IPD_COLORS.textSecondary, fontSize: 12, mt: 1 }}>
              Configured via REACT_APP_BACKEND_ROUTE_URL
            </Typography>
            <Box sx={{ mt: 2 }}>
              <InvButton loading={checking} variant="outlined" tone="teal" size="small" onClick={check}>
                Check Connection
              </InvButton>
            </Box>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={5}>
          <SectionCard title="Service Health">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ color: IPD_COLORS.textPrimary, fontSize: 13 }}>Inventory API</Typography>
              {healthy === undefined
                ? <Chip label="Unknown" size="small" sx={invChipSx({ color: IPD_COLORS.textPrimary })} />
                : healthy
                  ? <Chip label="Online" size="small" sx={invChipSx({ color: IPD_COLORS.success.text })} />
                  : <Chip label="Offline" size="small" sx={invChipSx({ color: IPD_COLORS.error.text })} />
              }
            </Box>
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );
}
